import styled from 'styled-components';
import { HeaderReset } from '@carvana/showroom-theme';
import { Close } from '../../icons';

export const ModalWrapper = styled.div`
  ${HeaderReset}
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 0;
  @media (min-width: ${p => p.theme.breakpoints.values.sm}px) {
    padding: 56px 0;
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: rgba(24, 53, 88, 0.3);
  z-index: -1;
`;

const mobileSizing = ({ variant }) =>
  variant === 'contained'
    ? `
    width: calc(100% - 48px);
    height: 440px;
    border-radius: 4px;
  `
    : '';

export const ModalContent = styled.div<{
  variant: string;
}>`
  position: relative;
  font-family: ${props => props.theme.typography.fontFamily};
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: 0;
  background: ${props => props.theme.carvana.gray.background};
  height: 100%;
  z-index: 1051;
  overflow-y: hidden;
  box-shadow: 0px 4px 8px rgba(24, 53, 88, 0.08),
    0px 8px 28px rgba(24, 53, 88, 0.04);
  ${mobileSizing}

  @media (min-width: ${p => p.theme.breakpoints.values.sm}px) {
    max-height: 100%;
    max-width: 704px;
    height: auto;
    border-radius: 4px;
  }
`;

export const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  color: ${props => props.theme.carvana.blue.dark};
  background: ${props => props.theme.carvana.white.primary};
  padding: 12px 0;
  box-shadow: 0px 0px 4px rgba(24, 53, 88, 0.16);
  z-index: 300;
  @media (min-width: ${p => p.theme.breakpoints.values.sm}px) {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }
`;

export const ModalScroll = styled.div`
  max-height: calc(100% - 40px);
  max-width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  @media (min-width: ${p => p.theme.breakpoints.values.sm}px) {
    max-height: calc(100vh - 152px);
  }
`;

export const ModalHeader = styled.h5`
  font-size: 16px;
  line-height: 1;
  font-weight: 700;
  text-align: center;
  margin: 0 auto;
  color: ${props => props.theme.carvana.blue.dark};
  @media (min-width: ${p => p.theme.breakpoints.values.sm}px) {
    font-size: 16px;
  }
`;

export const ModalCloseButton = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  line-height: 1;
  color: ${p => p.theme.carvana.blue.dark};
`;

export const CloseIcon = styled(Close)`
  width: 14px;
  height: 14px;
`;
